import { render, staticRenderFns } from "./MyAccreditationEventLandingPage.vue?vue&type=template&id=3bae01aa&scoped=true"
import script from "./MyAccreditationEventLandingPage.vue?vue&type=script&lang=js"
export * from "./MyAccreditationEventLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae01aa",
  null
  
)

export default component.exports